var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Busy',{attrs:{"value":_vm.busy}})
}
var staticRenderFns = []

export { render, staticRenderFns }